import { Box, Button, FormControl, FormHelperText, OutlinedInput, Typography } from "@mui/material";
import { push } from "connected-react-router";
import { useFormik } from "formik";
import { FC } from "react";
import { useDispatch } from "react-redux";
import * as Yup from 'yup'
import OdForm, { OnSubmit } from "~/components/formik/OdForm";
import TextField from "~/components/formik/TextField";
import { useDefaultSavedHandlers } from "~/controller/defaultSavedHandlers";
import { useSimpleSaveAction } from "~/controller/SaveContextProvider";
import { rPassword } from "~/pages/authentication/LoginContext";
import chainOptions from "~/utils/chainOptions";

const validationSchema =
  Yup.object().shape({
    password: Yup
      .string()
      .min(12)
      .max(255)
      .matches(
        rPassword, 
        'Password must contain uppercase and lowercase characters, numbers and special characters')
      .required('Password is required'),
    confirmPassword: Yup
      .string()
      .min(12)
      .max(255)
      .matches(
        rPassword, 
        'Password must contain uppercase and lowercase characters, numbers and special characters')
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),
  })
  
  
const ResetPasswordCollectForm: FC<{
  email: string,
  code: string,
  cid: string,
}> = ({email, code, cid}) => {
  const dispatch = useDispatch()
  const sendConfirm = useSimpleSaveAction()
  const initialValues = {
    submit: '',
    password: '',
    confirmPassword: '',
  }

  const handlers = useDefaultSavedHandlers("Password Reset")
  const onSubmit: OnSubmit<typeof initialValues> = (values, {
    setStatus,
    setErrors,
    setSubmitting,
  }) => {
    const options = {
      onSuccess: () => {
        setStatus({ success: true })
        setSubmitting(false)
        dispatch(push('/login'))
      },
      onFailure: (err: any) => {
        setStatus({ success: false })
        setErrors({ submit: err.message })
        setSubmitting(false)
      }
    }

    sendConfirm({ ...values, code, cid }, chainOptions(handlers, options))
  }

  const formikCtrl = useFormik({ initialValues, onSubmit, validationSchema })
  const { errors, isSubmitting } = formikCtrl

  return (
    <OdForm formikCtrl={formikCtrl}>
      
      <Typography
        color="textPrimary"
        variant="h6"
        sx={{ pb: 1 }}
      >
        Email Address
      </Typography>
      <FormControl 
        variant="outlined"
        fullWidth
        sx={{ pb: 3 }}
      >
        <OutlinedInput 
          value={email || ''}
          disabled
          inputProps={{ 'aria-label': 'email address' }}
        />
      </FormControl>

      <Typography
        color="textPrimary"
        variant="h6"
        sx={{ pb: 0 }}
      >
        Choose a Password
      </Typography>
      <TextField type="password" label="Password" name="password" sx={{ mt: 2, mb: 1}} />
      <TextField type="password" label="Confirm Password" name="confirmPassword" sx={{ mt: 2, mb: 1}} />
      {errors.submit && (
        <Box sx={{ mt: 3 }}>
          <FormHelperText error>
            {errors.submit}
          </FormHelperText>
        </Box>
      )}
      <Box sx={{ mt: 4 }} >
        <Button
          fullWidth
          color="primary"
          disabled={isSubmitting}
          size="large"
          type="submit"
          variant="contained"
        >
          Submit
        </Button>
      </Box>

    </OdForm>
  )
}

export default ResetPasswordCollectForm;
